module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.6bede58.ttf";